/* unplugin-vue-components disabled */import __unplugin_components_3 from '/home/pedrazzi/projetos/advogados/v5/src/components/Cookies.vue';
import __unplugin_components_2 from '~icons/mdi/email';
import __unplugin_components_1 from '~icons/mdi/whatsapp';
import __unplugin_components_0 from '~icons/mdi/phone-classic';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-footer",
    { staticClass: "app-footer mt-16", attrs: { padless: "" } },
    [
      _c(
        "v-card",
        {
          staticClass: "py-1 px-2 text-center",
          attrs: {
            light: "",
            flat: "",
            tile: "",
            color: _vm.theme.secondary,
            dark: "",
          },
        },
        [
          _c("div", { staticClass: "mt-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.site.end + " - " + _vm.site.city + "-" + _vm.site.state
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    text: "",
                    title: "clique aqui",
                    href: "tel:" + _vm.site.fone,
                  },
                },
                [
                  _c(__unplugin_components_0, {
                    staticStyle: { "font-size": "14px" },
                  }),
                  _vm._v("\n        " + _vm._s(_vm.site.fone)),
                ],
                1
              ),
              _vm._v(" "),
              _vm.site.whatsapp
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        "aria-label": "Whatsapp",
                        small: "",
                        href: _vm.openWhats(),
                        target: "_blank",
                      },
                    },
                    [
                      _c(__unplugin_components_1, {
                        staticStyle: { "font-size": "14px" },
                      }),
                      _vm._v(_vm._s(_vm.site.whatsapp)),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-1 mb-3" },
            [
              _vm._l(_vm.redes, function (item) {
                return _c(
                  "v-btn",
                  {
                    key: item.name,
                    attrs: {
                      small: "",
                      title: item.name,
                      href: item.url,
                      icon: "",
                    },
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(item.icon) } })]
                )
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    title: "contato",
                    small: "",
                    href: "./contato",
                    icon: "",
                  },
                },
                [_c(__unplugin_components_2)],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", [
            _c("small", [
              _vm._v("©\n        "),
              _vm.isMobile
                ? _c("span", [_vm._v(_vm._s(new Date().getFullYear()) + " - ")])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "white--text",
                  attrs: {
                    href: "https://agenciaideias.com.br",
                    target: "_blank",
                  },
                },
                [_vm._v("Agência Ideias")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(__unplugin_components_3, { attrs: { theme: _vm.theme } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }